<template>
  <div class="massaction-note-modal">
    <p class="modal-title">{{ isDirty ? $t('common.update') : $t('common.add') }} {{ $t('common.notes.notes')}}</p>
    <span class="adminNotes-label" v-if="notes && !showNotesLabel">{{ $t('common.notes.notes') }}</span>

    <div class="textarea-container">
      <b-form-textarea
        @input="updateModalIsTouched"
        :class="{
          'remove-padding': notes && showNotesLabel,
          'top-padding': notes && !showNotesLabel,
        }"
        v-model="notes"
        class="note-textarea"
        :placeholder="$t('common.notes.notes')"
        type="text"
        rows="4"
        no-resize
        maxlength="255"
      ></b-form-textarea>
    </div>
    <p v-if="isMandatory" class="adminNotes-note">
      <b style="font-weight: 700">{{ $t('common.notes.note') }}:</b> Notes must be at least 20
      characters.
    </p>
    <hr class="divider" />
    <div class="adminNotes-footer-btns">
      <button
        :disabled="
          (isMandatory && notes.length < 20) || (!modelIsTouched && isDirty)
        "
        class="btn add-btn"
        @click="onSubmit"
      >
        {{ isDirty ? $t('common.update') : $t('common.add') }}
      </button>
      <button class="btn cancel-btn" @click="$bvModal.hide('adminNotes')">
        {{  $t('common.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isMandatory: false,
      notes: "",
      showNotesLabel: true,
      modelIsTouched: false,
      isDirty: false,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  watch: {
    notes: {
      handler() {
        let textArea = document.querySelector(".note-textarea");
        this.showNotesLabel =
          textArea?.scrollHeight > textArea?.clientHeight + 3;
      },
      deep: true,
    },
  },
  methods: {
    onSubmit() {
      if (this.getModalInfo.allAction) {
        this.$emit("massActionNotesSubmit", {
          notes: this.notes,
          isDirty: this.notes.length > 0 ? true : false,
        });
      } else {
        this.$emit("notesSubmit", {
          notes: this.notes,
          isDirty: this.notes.length > 0 ? true : false,
          user_id: this.getModalInfo?.user_id,
        });
      }
      this.$bvModal.hide("adminNotes");
    },
    updateModalIsTouched() {
      this.modelIsTouched = true;
    },
  },
  beforeMount() {
    this.isMandatory = this.getModalInfo.isMandatory;
    this.notes = this.getModalInfo.adminNotes?.notes || "";
    this.isDirty = this.getModalInfo.adminNotes.isDirty;
  },
};
</script>

<style lang="scss">
.massaction-note-modal {
  .modal-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: start;
    margin-bottom: 40px;
    margin-inline-start: -20px;
  }
  .remove-padding {
    padding-top: -10px !important;
  }
  .top-padding {
    padding-top: 26px !important;
  }
  .divider {
    margin-top: 40px;
  }
  .note-textarea {
    background-color: #f2f2f2 !important;
    border-color: #f2f2f2 !important;
    width: 390px;
    height: 110px;
    border: none;
    resize: none;

    font-style: normal;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87) !important;
    opacity: 0.8 !important;
    border-radius: 4px;
    padding-inline-start: 20px !important;
  }
  .note-textarea::placeholder {
    position: relative;
    top: 4px;
  }
  .textarea-container {
    margin: 10px 10px 5px 10px;
  }
  .adminNotes-note {
    font-size: 14px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #939393;
    // opacity: 0.8 !important;
  }
  .adminNotes-label {
    position: absolute;
    margin-inline-start: 30px;
    margin-top: 6px;
    z-index: 2;
    color: #103f5e;
    font-size: 12px;
    opacity: 0.8;

    font-weight: 700;
    font-style: normal;
    line-height: 17px;
    letter-spacing: 0.25px;
    opacity: 0.8;
  }
  .adminNotes-footer-btns {
    display: flex;
    justify-content: space-between;
    width: 250px;
    margin: 25px auto 0 auto;
  }
  .btn {
    width: 111px;
    height: 33px;
    border-radius: 22px;
    border: 0;
  }
  .add-btn {
    background-color: #103f5e;
    color: #ffffff;
  }
  .cancel-btn {
    border: 1px solid #f46a6a;
    color: #f46a6a;
  }
}
</style>
